import { InjectionToken } from '@angular/core';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

export const BROWSER_AGENT = new InjectionToken<typeof BrowserAgent>(
  'BROWSER_AGENT',
  {
    providedIn: 'root',
    factory: () => BrowserAgent,
  }
);
